/**
 * El pulso del mercado: se queda con las cartas que sí tienen comparación
 * internacional (ADR 001 + 153).
 *
 * No calcula nada. Le pregunta a `vault-referencia.js`, el mismo motor que usa
 * la ficha de producto; aquí solo se decide qué filas sobreviven y cómo se dice
 * el veredicto en un renglón —el chip corto, no la frase larga de la ficha—.
 *
 * POR QUÉ HAY QUE FILTRAR DESDE AQUÍ. Solo ~57% de las cartas traen veredicto
 * (Scryfall tiene que conocerla y darle al menos $1 USD), y Liquid no puede
 * saber cuáles: eso se resuelve contra una API, en el navegador. Así que la
 * sección rinde 2.4 veces las filas que quiere mostrar —las primeras visibles,
 * el resto con `hidden`— y aquí se revelan las que resolvieron.
 *
 * Todo el pool se pide en UNA petición por lote, así que la decisión se toma de
 * golpe: un solo repintado a los ~400 ms en vez de filas apareciendo a tirones.
 *
 * Si esto no corre —sin JS, motor apagado, Scryfall caído— las filas se quedan
 * como las dejó Liquid: las primeras visibles, con arte y precio, sin chip. Es
 * exactamente lo que había antes, así que nunca se ve rota.
 */
(function () {
  function pintar(fila, r) {
    var chip = fila.querySelector('[data-pulso-veredicto]');
    if (chip) {
      chip.textContent = r.grado.icon + ' ' + r.grado.corto;
      chip.className = 'vault-pulso__chip vault-pulso__chip--ref vault-pulso__chip--' + r.grado.tono;
      chip.hidden = false;
    }

    /* El número contra el que se calculó el veredicto, junto al nuestro: sin él
       el porcentaje es una afirmación sin cifra. Solo cuando hay costo puesto en
       México configurado — si no, "traerla" sería el precio de lista y estaríamos
       comparando contra algo que nadie paga. */
    var traerla = fila.querySelector('[data-pulso-traerla]');
    if (traerla && r.hayCostoPuesto) {
      traerla.textContent = 'traerla ' + r.alternativaTexto;
      traerla.hidden = false;
    }
  }

  function decidir(filas, resultados, objetivo) {
    var mostradas = 0;

    filas.forEach(function (fila, i) {
      var r = resultados[i];
      if (r && mostradas < objetivo) {
        pintar(fila, r);
        /* El orden entre las que se ven: de él dependen la línea entre columnas
           y el corte a seis en móvil. Liquid lo puso suponiendo que se verían
           las primeras; ahora que se sabe cuáles son de verdad, se corrige. */
        fila.dataset.orden = mostradas;
        fila.hidden = false;
        mostradas++;
      } else {
        fila.hidden = true;
      }
    });

    /* Si el pool no dio para llenar, se completa con las que no tienen
       veredicto en vez de dejar la sección corta. Una fila sin chip sigue siendo
       una carta con su arte y su precio; media sección vacía no es nada. */
    if (mostradas < objetivo) {
      filas.forEach(function (fila, i) {
        if (mostradas >= objetivo || resultados[i]) return;
        fila.dataset.orden = mostradas;
        fila.hidden = false;
        mostradas++;
      });
    }
  }

  function arrancar() {
    document.querySelectorAll('[data-vault-pulso]').forEach(function (tabla) {
      var filas = [].slice.call(tabla.querySelectorAll('[data-vault-pulso-ref]'));
      if (!filas.length) return;

      var objetivo = Number(tabla.dataset.objetivo) || filas.length;

      window.vaultReferencia
        .precargar(filas.map(function (f) { return f.dataset.sku; }))
        .then(function () {
          /* Después de la precarga las cartas salen de memoria y el tipo de
             cambio es una sola promesa compartida, así que esto no dispara una
             petición por fila. */
          return Promise.all(filas.map(function (f) {
            return window.vaultReferencia.resolver(f.dataset.sku, f.dataset.mxn);
          }));
        })
        .then(function (resultados) {
          decidir(filas, resultados, objetivo);
        })
        .catch(function () {
          /* Se quedan las que Liquid dejó visibles. */
        });
    });
  }

  /* El motor se carga con `defer`: todavía no existe. Se deja apuntado en la
     cola y él da paso al instalarse. */
  (window.vaultReferenciaCola = window.vaultReferenciaCola || []).push(arrancar);
})();
